import type { MatchesCalendarMode } from './types';
import { MatchesCalendarData } from './types';

import type { StateCreator } from '@shared-types/zustand.types';

const hasObjectChanges = (current: Record<string, any>, incoming: Record<string, any>): boolean => {
  return Object.keys(incoming).some((key) => current[key] !== incoming[key]);
};

type FiltersSlice = {
  filters: Record<string, any>;
  setFilters: (payload: Record<string, any>) => void;
};

const filtersSlice: StateCreator<FiltersSlice> = (set) => ({
  filters: {},
  setFilters: (payload) =>
    set(
      (state) => {
        if (!hasObjectChanges(state.filters, payload)) return state;

        return { filters: { ...state.filters, ...payload } };
      },
      false,
      'setFilters',
    ),
});

type ActiveDataSlice = {
  activeData: Record<MatchesCalendarData, boolean>;
  setActiveData: (payload: Record<MatchesCalendarData, boolean>) => void;
};

const dataSlice: StateCreator<ActiveDataSlice> = (set) => ({
  activeData: {
    [MatchesCalendarData.MATCHES]: true,
    [MatchesCalendarData.FRIENDLIES]: false,
    [MatchesCalendarData.DRAWS]: true,
  },
  setActiveData: (payload) =>
    set(
      (state) => {
        if (!hasObjectChanges(state.activeData, payload)) return state;

        return { activeData: { ...state.activeData, ...payload } };
      },
      false,
      'setActiveData',
    ),
});

type ModeSlice = {
  mode: MatchesCalendarMode;
  setMode: (payload: MatchesCalendarMode) => void;
};

const modeSlice: StateCreator<ModeSlice> = (set) => ({
  mode: null,
  setMode: (payload) =>
    set(
      (state) => {
        if (state.mode === payload) return state;

        return { mode: payload };
      },
      false,
      'setMode',
    ),
});

type TeamsSlice = {
  teams: Record<string, string>;
  setTeams: (payload: Record<string, string>) => void;
};
const teamsSlice: StateCreator<TeamsSlice> = (set) => ({
  teams: {},
  setTeams: (payload) =>
    set(
      (state) => {
        if (!hasObjectChanges(state.teams, payload)) return state;

        return { teams: { ...state.teams, ...payload } };
      },
      false,
      'setTeams',
    ),
});
export type MatchesCalendarState = FiltersSlice & ActiveDataSlice & ModeSlice & TeamsSlice;

export const reducer: StateCreator<MatchesCalendarState> = (...args) => ({
  ...filtersSlice(...args),
  ...dataSlice(...args),
  ...modeSlice(...args),
  ...teamsSlice(...args),
});
